/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { holidays_BulkCreateHolidaysRequest } from '../models/holidays_BulkCreateHolidaysRequest';
import type { holidays_CheckHolidayRequest } from '../models/holidays_CheckHolidayRequest';
import type { holidays_CheckHolidayResponse } from '../models/holidays_CheckHolidayResponse';
import type { holidays_CreateHolidayRequest } from '../models/holidays_CreateHolidayRequest';
import type { holidays_HolidayListResponse } from '../models/holidays_HolidayListResponse';
import type { holidays_HolidayResponse } from '../models/holidays_HolidayResponse';
import type { holidays_UpdateHolidayRequest } from '../models/holidays_UpdateHolidayRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HolidaysService {
    /**
     * Create holiday
     * Create a new holiday or closure date
     * @param request Holiday details
     * @returns holidays_HolidayResponse Created
     * @throws ApiError
     */
    public static postApiV1Holidays(
        request: holidays_CreateHolidayRequest,
    ): CancelablePromise<holidays_HolidayResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/holidays',
            body: request,
            errors: {
                400: `Validation errors or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                500: `Failed to create holiday`,
            },
        });
    }
    /**
     * Delete holiday
     * Soft-delete a holiday
     * @param id Holiday ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Holidays(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/holidays/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Holiday not found`,
                500: `Failed to delete holiday`,
            },
        });
    }
    /**
     * Get holiday
     * Get holiday details by ID
     * @param id Holiday ID
     * @returns holidays_HolidayResponse OK
     * @throws ApiError
     */
    public static getApiV1Holidays(
        id: string,
    ): CancelablePromise<holidays_HolidayResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/holidays/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                404: `Holiday not found`,
                500: `Failed to get holiday`,
            },
        });
    }
    /**
     * Update holiday
     * Update holiday details
     * @param id Holiday ID
     * @param request Updated holiday details
     * @returns holidays_HolidayResponse OK
     * @throws ApiError
     */
    public static putApiV1Holidays(
        id: string,
        request: holidays_UpdateHolidayRequest,
    ): CancelablePromise<holidays_HolidayResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/holidays/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                404: `Holiday not found`,
                500: `Failed to update holiday`,
            },
        });
    }
    /**
     * Bulk create holidays
     * Create multiple holidays in a single request (max 1000)
     * @param request Bulk holiday creation
     * @returns holidays_HolidayListResponse Created
     * @throws ApiError
     */
    public static postApiV1HolidaysBulk(
        request: holidays_BulkCreateHolidaysRequest,
    ): CancelablePromise<holidays_HolidayListResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/holidays/bulk',
            body: request,
            errors: {
                400: `Validation errors or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `User or Organization ID not found in token`,
                500: `Failed to create holidays`,
            },
        });
    }
    /**
     * List holidays by canton
     * List all holidays for a specific canton
     * @param canton Canton code
     * @returns holidays_HolidayListResponse OK
     * @throws ApiError
     */
    public static getApiV1HolidaysCanton(
        canton: string,
    ): CancelablePromise<holidays_HolidayListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/holidays/canton/{canton}',
            path: {
                'canton': canton,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list holidays`,
            },
        });
    }
    /**
     * Check if date is holiday
     * Check if a specific date is a holiday for a region. Date is parsed as UTC midnight with time.Parse("2006-01-02"); no automatic timezone inference is performed.
     * @param request Date and region to check
     * @returns holidays_CheckHolidayResponse OK
     * @throws ApiError
     */
    public static postApiV1HolidaysCheck(
        request: holidays_CheckHolidayRequest,
    ): CancelablePromise<holidays_CheckHolidayResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/holidays/check',
            body: request,
            errors: {
                400: `Validation errors or invalid date format`,
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to check holiday`,
            },
        });
    }
    /**
     * List holidays by country
     * List all holidays for a specific country
     * @param country Country code (ISO 3166-1 alpha-2)
     * @returns holidays_HolidayListResponse OK
     * @throws ApiError
     */
    public static getApiV1HolidaysCountry(
        country: string,
    ): CancelablePromise<holidays_HolidayListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/holidays/country/{country}',
            path: {
                'country': country,
            },
            errors: {
                401: `Authentication required or invalid credentials`,
                403: `Organization ID not found in token`,
                500: `Failed to list holidays`,
            },
        });
    }
}
